"use client";

import React from "react";
import BeneficiaryCard from "../../Create/components/BeneficiaryCard.jsx";
import beneficiaryModalStyles from "../../Create/css/BeneficiaryModal.module.css";

const BeneficiariesPopup = ({ onClose, overlay = false, data }) => {
  const rawBen = Array.isArray(data?.beneficiaries) ? data.beneficiaries : [];

  const forms = rawBen.map((b, idx) => {
    const homeParts = String(b.homeaddress || "")
      .split(",")
      .map((s) => s.trim());

    const d = b.deliveryaddress;
    let delivery = { street: "", suburb: "", city: "", postalCode: "" };
    if (d && typeof d === "object" && !Array.isArray(d) && d["Delivery Address 1"]) {
      const obj = d["Delivery Address 1"] || {};
      delivery = {
        street: obj.street || "",
        suburb: obj.suburb || "",
        city: obj.city || "",
        postalCode: obj.postalCode || obj.postal || "",
      };
    } else if (d) {
      const parts = String(d)
        .split(",")
        .map((s) => s.trim());
      delivery = {
        street: parts[0] || "",
        suburb: parts[1] || "",
        city: parts[2] || "",
        postalCode: parts[3] || "",
      };
    }

    const chronic = Array.isArray(b.chronicconditions)
      ? b.chronicconditions.join(", ")
      : b.chronicconditions || "";

    return {
      id: idx + 1,
      surname: b.surname || "",
      initial: (b.firstname || "").slice(0, 1).toUpperCase(),
      title: b.title || "",
      firstNames: b.firstname || "",
      dateOfBirth: b.dateofbirth ? String(b.dateofbirth).slice(0, 10) : "",
      idNumber: b.idnumber || "",
      dependentCode: b.dependentcode || "",
      age: b.age ?? "",
      weight: b.weightinkg ?? "",
      sex: b.sex || "",
      chronicConditions: chronic,
      homeStreet: homeParts[0] || "",
      homeSuburb: homeParts[1] || "",
      homeCity: homeParts[2] || "",
      homePostalCode: homeParts[3] || "",
      deliveryStreet: delivery.street || "",
      deliverySuburb: delivery.suburb || "",
      deliveryCity: delivery.city || "",
      deliveryPostalCode: delivery.postalCode || "",
    };
  });

  const totalCount = forms.length;
  const needScroll = totalCount > 4;

  const innerContent = (
    <div className={`${beneficiaryModalStyles.modalContent} ${beneficiaryModalStyles.modalContentAuto}`}>
      <div className={beneficiaryModalStyles.modalCard}>
        <div className={beneficiaryModalStyles.modalHeader}>
          <div className={beneficiaryModalStyles.titleRow}>
            <h2>Beneficiary List</h2>
            {totalCount > 0 && (
              <span className={beneficiaryModalStyles.countText}>{totalCount}</span>
            )}
          </div>
          <div className={beneficiaryModalStyles.headerActions}>
            <button
              className={beneficiaryModalStyles.closeX}
              aria-label="Close"
              onClick={onClose}
            >
              ×
            </button>
          </div>
        </div>

        <div
          className={`${beneficiaryModalStyles.cardsGrid} ${
            needScroll
              ? beneficiaryModalStyles.cardsGridScrollable
              : beneficiaryModalStyles.cardsGridNoScroll
          } ${!needScroll ? beneficiaryModalStyles.cardsGridCentered : ""}`}
        >
          {forms.map((form, index) => (
            <BeneficiaryCard
              key={index}
              index={index}
              value={{
                surname: form.surname,
                title: form.title,
                firstNames: form.firstNames,
                dob: form.dateOfBirth,
                idType: "id",
                idNumber: form.idNumber,
                dependentCode: form.dependentCode,
                age: form.age,
                weight: form.weight,
                sex: form.sex,
                conditions: form.chronicConditions,
                conditionsExtra: [],
                allergiesList: [""],
                cell: "",
                homeStreet: form.homeStreet,
                homeSuburb: form.homeSuburb,
                homeCity: form.homeCity,
                homePostalCode: form.homePostalCode,
                deliveryStreet: form.deliveryStreet,
                deliverySuburb: form.deliverySuburb,
                deliveryCity: form.deliveryCity,
                deliveryPostalCode: form.deliveryPostalCode,
                deliveryAddressesExtra: [],
              }}
              onChange={() => {}}
              onRemove={() => {}}
              isUpdateMode={false}
              hideActions={true}
              isHidden={false}
              mainHome={{}}
              mainDelivery={{}}
            />
          ))}
        </div>
      </div>
    </div>
  );

  if (overlay) {
    return <div className={beneficiaryModalStyles.modalPopup}>{innerContent}</div>;
  }

  return innerContent;
};

export default BeneficiariesPopup;
